import { MessageService } from 'primeng/api';

import { inject, Injectable } from '@angular/core';

interface ToastMessageOptions {
  summary: string;
  detail?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly messageService = inject(MessageService);

  info(message: ToastMessageOptions): void {
    this.messageService.add({ severity: 'info', ...message });
  }

  success(message: ToastMessageOptions): void {
    this.messageService.add({ severity: 'success', ...message });
  }

  error(message: ToastMessageOptions): void {
    this.messageService.add({ severity: 'error', ...message });
  }
}
